import React  from "react";
import { Flex, Box,Image} from '@chakra-ui/react';
import {useState,useEffect} from "react"

import {
    ChevronLeftIcon,
    ChevronRightIcon,
  } from '@chakra-ui/icons';
import "./success.css"
export const SuccessStories=()=>{
  
    
    const fData=
    [
        {
    img:'https://kettocdn.gumlet.io/media/banner/0/96/image/0717875196afb641172a631c282e1875d76b8930.jpg?w=auto&dpr=1.0',
    des:"Heroes like you helped my son win his battle",
    DES1:"May Allah bless you all! Thanks to your generous donations, Afzal underwent a successful BMT to treat thalassemia major. We are eternally grateful to you all for gifting our little bundle of joy a second chance at life!” -Reshma (Mother)"
        },
        {
            img:'https://kettocdn.gumlet.io/media/banner/0/95/image/bc5ae443b8da492ff0c97082e2981ada078e385d.jpg?w=auto&dpr=1.0',
            des:"My daughter finally gets to enjoy her childhood",
            DES1:"My daughter was suffering from Budd Chiari syndrome with a recurrent gastrointestinal bleed and needed an urgent liver transplant to survive, but sadly we couldn't afford it. However, your donations gave her a new lease on life! She underwent a successful liver transplant and is now enjoying her childhood. Words cannot express how grateful I am to you angels!- Prajakta (Mother)"
            
                },
                {
                    img:'https://kettocdn.gumlet.io/media/banner/0/94/image/26fe5c8a80fe779e091bd15f4de3c80224ca7c5b.jpg?w=auto&dpr=1.0',
                    des:"Your support gave my son a second chance at life",
                    DES1:"I express my heartfelt gratitude towards you all for saving my son, Vedant's life! He was suffering from CLD Budd Chiari Syndrome, and a liver transplant was his only hope at survival, but we couldn't afford it. We would've lost him had it not been for your generosity and prayers. Thank you for lighting up our lives. He is doing better than ever post his liver transplant."

                    
                        },
]
    const [data, setData] = useState(fData);
useEffect(() => {
    if (data.length === 0) {
        setData(fData);
    }
}, [fData, data.length]);
    
    const handlePrev = () => {
        let d = [...data];
        let x = d.pop();
        d.unshift(x);
        setData(d);
    }
    const handleNext = () => {

        let d = [...data];
        let x = d.shift();
        d.push(x);
        setData(d);
    }
    // console.log(cards[0])
    return (
    <Flex className='rs-succ'justify='center' align='center'>
           <Box onClick={handlePrev} ><ChevronLeftIcon w='12' h='12' color='#01BFBD'
/></Box>
            <Flex w="90%" justify='center' gap='5%' height='fit-content' >
                {data?.filter((item, index) => index < 1).map((item) => (
                    <div className="rs-succ-flex" key={item.des}>
                        <div className="rs-succ-img"><Image src={item.img} key={item.img} width='100%' /></div>
                        <div className="rs-succ-data">
                        <h1 className='rs-succ-title'>{item.des}</h1>
                            <p className='rs-succ-p'>{item.DES1}</p>
                            <br />
                            <p style={{ color: 'gray' }}>subscribe to read such inspiring stories</p>
                            <br/>
                            <button className="rs-succ-btn">Subscribe</button>
                        </div>
                    </div>
                ))}
           </Flex>
           <Box onClick={handleNext}><ChevronRightIcon w='12' h='12' color='#01BFBD'/>
</Box>
    </Flex>
    )
}